import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { getStyles } from "./Mission.styles";

const Mission = () => {
  const styles = getStyles();

  return (
    <Box sx={styles.missionContainer}>
      <Box sx={styles.missionSection}>
        <Box sx={styles.missionImage}>
          <img
            src="/assets/images/our-mission.png"
            alt="Mission Illustration"
          />
        </Box>
        <Box sx={styles.missionDescription}>
          <Typography variant="h2" component="h2" gutterBottom>
            Misiunea Bookster
          </Typography>
          <Typography variant="h5" component="p">
            Inspirăm oamenii să își descopere visurile și să le atingă, prin
            lectură.
            <br />
            <br />
            Ajută-ne să ducem această inspirație mai departe, către copiii care
            încă speră să-și găsească visul într-o carte.
          </Typography>
          <Button
            variant="contained"
            color="info"
            size="large"
            sx={styles.button}
            onClick={() => {
              window.open("https://tinyurl.com/58t98krr", "_blank");
            }}
          >
            Află mai multe despre Bookster
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Mission;
